import React from 'react';

export const OnCallGlyph = (props: { [key: string]: string }) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.952 5C7.574 5 7.231 5.271 7.078 5.69C6.362 7.648 6 9.712 6 11.827V11.981C6 14.138 6.36 16.25 7.072 18.256C7.239 18.725 7.584 19 7.967 19H9.416L9.209 16.506H7.562L7.415 15.683C7.192 14.44 7.079 13.195 7.079 11.981V11.827C7.079 10.66 7.183 9.48 7.39 8.32L7.536 7.495H9.209L9.416 5H7.952ZM11.41 18.833C11.507 20 10.586 21 9.415 21H7.967C6.744 21 5.634 20.183 5.203 18.967C4.399 16.703 4 14.366 4 11.981V11.827C4 9.478 4.403 7.182 5.199 5.004C5.643 3.787 6.724 3 7.952 3H9.415C10.586 3 11.507 4 11.41 5.167L11.199 7.704C11.115 8.716 10.269 9.495 9.254 9.495H9.231C9.13 10.271 9.079 11.052 9.079 11.827V11.981C9.079 12.81 9.138 13.656 9.254 14.506C10.269 14.506 11.115 15.285 11.199 16.296L11.41 18.833ZM19.3183 12C19.3183 12.829 18.6463 13.5 17.8183 13.5C16.9903 13.5 16.3183 12.829 16.3183 12C16.3183 11.172 16.9903 10.5 17.8183 10.5C18.6463 10.5 19.3183 11.172 19.3183 12ZM12.8183 13.5C13.6463 13.5 14.3183 12.829 14.3183 12C14.3183 11.172 13.6463 10.5 12.8183 10.5C11.9903 10.5 11.3183 11.172 11.3183 12C11.3183 12.829 11.9903 13.5 12.8183 13.5Z"
			fill="currentColor"
		/>
	</svg>
);
